<template>
  <div class="proxyIp pointer">
    <div class="navBar">
      <div class="fanhuiBox" @click="getBack">
        <img class="fanhui" src="@/assets/icons/fanhui.png" alt="" />
      </div>
      <div class="title">
        <p>代理IP</p>
      </div>
      <div class="navBtn" @click="recordPage">代理记录</div>
    </div>
    <div class="main">
      <div class="cardBox">
        <div class="card" @click="selecteQuipment">
          <p>选择代理设备</p>
          <div
            :class="['no_equipment', ifMark ? 'mark' : '']"
            v-show="equipmentList.length <= 0"
          >
            暂未选择设备
          </div>
          <div class="no_equipment" v-show="equipmentList.length > 0">
            已选择<span class="sp1">{{ equipmentList.length }}</span
            >台设备
          </div>
          <img src="@/assets/icons/xuenze.png" alt="" />
        </div>
        <div class="equipmentDetails" v-if="equipmentList.length > 0">
          <div class="packUpBox" v-if="!unfoldShow">
            <div>{{ equipmentList[0].instanceName }}</div>
            <div class="viewAll" @click="unfoldShow = true">
              <div>查看全部</div>
              <img src="@/assets/icons/down_arrows.png" alt="" />
            </div>
          </div>
          <div class="unfoldBox" v-else>
            <div class="line"></div>
            <div
              class="unfoldItem"
              v-for="item in equipmentList"
              :key="item.id"
            >
              {{ item.instanceName }}
            </div>
            <div class="unfoldName" @click="unfoldShow = false">
              <div>收起</div>
              <img src="../../../assets/icons/unfoldName.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="sq_zh">
        <van-form @submit="onSubmit" ref="proxyForm">
          <p>代理类型</p>
          <van-cell-group class="phoneFrame">
            <van-field
              v-model="proxyIpForm.proxyType"
              type="tel"
              placeholder="请输入代理类型"
              disabled
              class="inputBack"
              :rules="[{ required: true, message: '' }]"
            />
          </van-cell-group>
          <p>IP地址</p>
          <van-cell-group class="phoneFrame">
            <van-field
              v-model="proxyIpForm.ip"
              type="tel"
              placeholder="请输入IP地址"
              class="inputBack"
              :rules="[{ required: true, message: '' }]"
            />
          </van-cell-group>
          <p>服务器端口</p>
          <van-cell-group class="phoneFrame">
            <van-field
              v-model="proxyIpForm.port"
              type="tel"
              placeholder="请输入服务器端口"
              class="inputBack"
              :rules="[{ required: true, message: '' }]"
            />
          </van-cell-group>
          <p>用户名</p>
          <van-cell-group class="phoneFrame">
            <van-field
              v-model="proxyIpForm.userName"
              type="tel"
              placeholder="请输入用户名"
              class="inputBack"
              :rules="[{ required: true, message: '' }]"
            />
          </van-cell-group>
          <p>密码</p>
          <van-cell-group class="phoneFrame">
            <van-field
              v-model="proxyIpForm.password"
              type="tel"
              placeholder="请输入密码"
              class="inputBack"
              :rules="[{ required: true, message: '' }]"
            />
          </van-cell-group>
        </van-form>
      </div>
    </div>
    <div class="baseBox">
      <button @click="handleSubmit" class="qdsq_btn">确认开启代理</button>
    </div>
    <Loading v-model="showDialog" text="正在代理IP..."> </Loading>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import { setUserProxyIp } from "@/api/index.js";
import Loading from "@/components/publicDialog/Loading.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "ProxyIp",
  components: {
    Loading,
  },
  data() {
    return {
      userdata: {},
      show: false,
      equipmentList: [],
      unfoldShow: false,
      showDialog: false,
      proxyIpForm: {
        proxyType: "socks5",
      },
      ifMark: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.beforeUrl = from.path;
    });
  },
  destroyed() {
    this.SET_GLOBALPROXYIPFORM(this.proxyIpForm);
  },
  mounted() {
    this.userdata = JSON.parse(localStorage.getItem("data"));
    this.getProxyIpForm();
  },
  computed: {
    //数组写法
    ...mapState("common", ["proxyEquipmentList", "globalProxyIpForm"]),
  },

  methods: {
    ...mapMutations("common", [
      "SET_PROXYEQUIPMENTLIST",
      "SET_GLOBALPROXYIPFORM",
    ]),
    getProxyIpForm() {
      let that = this;
      that.$nextTick(() => {
        if (that.beforeUrl == "/choiceProxyDevice") {
          that.equipmentList = that.proxyEquipmentList;
          let equivalence =
            that.proxyEquipmentList.length === 0
              ? false
              : that.proxyEquipmentList.every((item) => {
                  return (
                    item.account === that.proxyEquipmentList[0].account &&
                    item.password === that.proxyEquipmentList[0].password &&
                    item.proxyIp === that.proxyEquipmentList[0].proxyIp &&
                    item.serverPort === that.proxyEquipmentList[0].serverPort
                  );
                });
          if (equivalence) {
            that.proxyIpForm = {
              proxyType: "socks5",
              ip: that.proxyEquipmentList[0].proxyIp,
              port: that.proxyEquipmentList[0].serverPort,
              userName: that.proxyEquipmentList[0].account,
              password: that.proxyEquipmentList[0].password,
            };
          } else {
            that.proxyIpForm = that.globalProxyIpForm;
          }
        } else {
          that.SET_PROXYEQUIPMENTLIST([]);
        }
      });
    },
    getBack() {
      this.$router.go(-1);
    },
    recordPage() {
      this.$router.push("proxyIpRecord");
    },
    handleSubmit() {
      this.$refs.proxyForm.submit();
    },
    // 确认代理
    onSubmit(values) {
      if (this.equipmentList.length <= 0) {
        this.ifMark = true;
        Toast("请选择要代理的设备");
        return;
      }
      this.showDialog = true;
      this.handleProxyIp(this.equipmentList, "add");
      // const addList = this.equipmentList.filter((item) => !item.proxyId);
      // const upDataList = this.equipmentList.filter((item) => item.proxyId);
      // if (addList.length > 0) {
      //   this.handleProxyIp(addList, "add");
      // }
      // if (upDataList.length > 0) {
      //   this.handleProxyIp(upDataList, "upData");
      // }
    },
    handleProxyIp(list, type) {
      let parameters = this.proxyIpForm;
      let bdScriptContent = `dg apt uninstall plugin:proxy;dg apt install plugin:proxy;dg config -r proxy -a proxy.enabled=true -a proxy.protocol=${parameters.proxyType} -a proxy.host=${parameters.ip} -a proxy.port=${parameters.port} -a proxy.user=${parameters.userName} -a proxy.pass=${parameters.password}`;
      let intelligentScriptContent = `gm config -a 'proxy.enabled=true;proxy.host=${parameters.ip};proxy.port=${parameters.port};proxy.protocol=${parameters.proxyType};proxy.user=${parameters.userName};proxy.password=${parameters.password}'`;
      let hwScriptContent = `proxy -r ${parameters.proxyType} -a ${parameters.ip} -p ${parameters.port} -s ${parameters.userName} -k ${parameters.password} -e`;
      // if (type == "upDataList") {
      //   bdScriptContent = `dg config -r proxy -a proxy.enabled=true -a proxy.protocol=${parameters.proxyType} -a proxy.host=${parameters.ip} -a proxy.port=${parameters.port} -a proxy.user=${parameters.userName} -a proxy.pass=${parameters.password}`;
      // }
      let ids = list.map(function (item) {
        return item.instanceId;
      });
      let appUserInstanceProxyIpRecordList = list.map(function (item) {
        return {
          id: item.proxyId,
          instanceCode: item.instanceCode,
          account: parameters.userName,
          password: parameters.password,
          proxyIp: parameters.ip,
          serverPort: parameters.port,
        };
      });
      let data = {
        appUserInstanceProxyIpRecordList,
        bdScriptContent,
        hwScriptContent,
        ids,
        intelligentScriptContent,
        operationType: 0,
      };
      setUserProxyIp(data)
        .then((res) => {
          this.showDialog = false;
          if (res.code == 200) {
            Toast(res.msg);
            this.$router.push("proxyIpRecord");
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          this.showDialog = false;
        });
    },
    selecteQuipment() {
      this.$router.push({ path: "/choiceProxyDevice" });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.proxyIp {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.navBar {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .fanhuiBox {
    height: 100%;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    .fanhui {
      width: 17px;
      height: 17px;
    }
  }
  .title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: 600;
    font-size: 17px;
  }
  .navBtn {
    margin-right: 12px;
    color: #886df3;
  }
}
.main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding: 10px 16px 16px 16px;
  .cardBox {
  }
  .equipmentDetails {
    background: #fff;
    height: 36px;
    padding: 0 12px;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: -10px;
    position: relative;
    color: #666;
    font-size: 10px;
    position: relative;
    .packUpBox {
      // position: absolute;
      border-top: 1px solid #c6c9d1;
      display: flex;
      justify-content: space-between;
      line-height: 36px;
      .viewAll {
        display: flex;
        align-items: center;
        img {
          width: 7px;
          height: 4px;
          margin-left: 5px;
        }
      }
    }
    .unfoldBox {
      .line {
        background-color: #c6c9d1;
        height: 1px;
        width: 100%;
      }
      position: absolute;
      left: 0;
      width: 343px;
      text-align: left;
      padding: 0 12px;
      box-sizing: border-box;
      background: #fff;
      max-height: 355px;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 999;
      .unfoldItem {
        height: 35px;
        line-height: 35px;
        border-bottom: 1px solid #e8e9ed;
      }
      .unfoldName {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 35px;
        line-height: 35px;
        font-size: 10px;
        color: #666;
        img {
          width: 7px;
          height: 4px;
          margin-left: 4px;
        }
      }
    }
  }

  .card {
    height: 64px;
    background: #ffffff;
    padding: 0 12px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    p {
      flex: 1;
      text-align: left;
      font-size: 15px;
      color: #303030;
    }
    .no_equipment {
      font-size: 12px;
      color: #666666;
      margin-left: 8px;
      .sp1 {
        color: #ff5719;
      }
    }
    .mark {
      color: #ff5719;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
  .sq_zh {
    margin: 16px 0;
    background: #ffffff;
    padding: 6px 12px 18px 12px;
    border-radius: 10px 10px 10px 10px;
    text-align: left;
    .inputBack {
      background-color: #f4f4f4;
      border-radius: 40px;
    }
    .phoneFrame {
      margin-bottom: 7px;
    }
    .verificationBox {
      margin-top: 28px;
    }
    .agreementBox {
      margin-top: 42px;
      /deep/.van-checkbox__label {
        font-size: 10px !important;
        color: #666666 !important;
        margin-left: 5px;
        margin-top: -2px;
        a {
          color: #0066ff !important;
        }
      }
    }
    p {
      margin: 12px 0 8px 0;
      font-size: 15px;
    }
    /deep/.van-radio__label--left {
      font-size: 16px;
      color: #303030;
      margin-right: 5px;
    }
    /deep/.van-radio--horizontal {
      margin-right: 30px;
    }
    // p {
    //   margin: 0 0 10px 0;
    //   display: flex;
    //   align-items: center;
    //   font-size: 15px;
    //   color: #303030;
    //   span {
    //     flex: 1;
    //   }
    //   .yzmbtn {
    //     width: 108px;
    //     height: 30px;
    //     background: rgb(0, 102, 255);
    //     border-radius: 15px;
    //     color: rgb(255, 255, 255);
    //     font-family: PingFang SC;
    //     font-size: 15px;
    //     font-weight: 400;
    //     line-height: 21px;
    //     letter-spacing: 0px;
    //     text-align: center;
    //     border: none;
    //   }
    //   .yzm_btns {
    //     border: none;
    //     font-size: 16px;
    //     font-family: PingFang SC-Medium, PingFang SC;
    //     font-weight: 500;
    //     background: none;
    //     color: #999999;
    //   }
    // }
  }
  .sq_gz {
    margin: 16px 0;
    text-align: left;
    font-size: 12px;
    background: #fff;
    border-radius: 8px;
    padding: 18px 12px;
    margin-top: 20px;
    .sq_gz_btn {
      margin: 20px auto 0 auto;
      width: 315px;
      height: 44px;
      border: none;
      background: #da3640;
      border-radius: 4px;
      font-size: 16px;
      color: #f6f8fb;
      line-height: 23px;
      letter-spacing: 0px;
      text-align: center;
    }
  }
  .qdsq_btn {
    margin: 20px auto 0 auto;
    width: 315px;
    height: 44px;
    border: none;
    background: #0066ff;
    border-radius: 4px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}

.xuanzeysj {
  .van-cell {
    background: rgba(20, 93, 250, 0.06);
    width: calc(100% - 32px);
    margin: 10px 16px 16px;
    border-radius: 10px 10px 10px 10px;
  }
  .van-cell-group {
    overflow: auto;
    background: none;
  }
  .van-cell::after {
    border: none;
  }
}
.lilis {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
  }
  div {
    margin-left: 16px;
    flex: 1;
    text-align: left;
    p {
      margin: 2px 0;
    }
  }
}
.baseBox {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 8px 0 hsla(0, 0%, 39%, 0.2);
  color: #333;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 0;
  .qdsq_btn {
    width: 90%;
    height: 44px;
    border: none;
    background: #886df3;
    border-radius: 44px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}
/deep/ .van-hairline--top-bottom::after {
  border: none;
}
/deep/.van-cell {
  background: rgba(20, 93, 250, 0.06);
  border-radius: 4px;
}
/deep/.van-field__body {
  height: 20px;
}
</style>